module.exports = __webpack_public_path__ + "img/windy_dash.2330ea17.svg";